var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shedule-back"},[_c('div',{staticClass:"desktop"},[_c('ListScheduleBack')],1),_c('div',{staticClass:"mobile-app"},[_c('MoblieScreenBack')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }